import * as React from "react";

const CommerceService = React.lazy(() => import("./commerce.container"));

export { CommerceService };
